import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAPAlternatePlanListDatasource } from '../alternate_plans/datasources/alternate_plan_list_datasource';
import { AlternatePlanComparePlansModel } from '../alternate_plans/models/alternate_plan_compare_plans_model';
import { APModel } from '../global/models/ap_model';

export const AlternatePlanRoute = <ng.ui.IState>{
  url: 'alternate-plans/',
  data: {
    pageTitle: 'Alternate plans'
  },
  template: `
    <ui-view name='modal'></ui-view>
    <alternate-plans></alternate-plans>
        `,
  resolve: {
    hasCurrentPgmFilled: (ngAPModel: APModel, loadAcademicPlanCommand: ICommand) => {
      if (!_4.isUndefined(_4.get(ngAPModel.currentProgram(), 'id'))) {
        return true;
      }
      return loadAcademicPlanCommand();
    },
    availablePlanListFilled: (
      ngAPAlternatePlanListDatasource: IAPAlternatePlanListDatasource,
      loadAlternatePlanListCommand: ICommand,
      hasCurrentPgmFilled: any
    ) => loadAlternatePlanListCommand(),
    basePlanDetails: (
      ngAPModel: APModel,
      loadAlternatePlanDetailsCommand: ICommand,
      availablePlanListFilled: any,
      ngAlternatePlanComparePlansModel: AlternatePlanComparePlansModel
    ) => {
      ngAlternatePlanComparePlansModel.clear();
      const currentProgram = ngAPModel.currentProgram();
      return loadAlternatePlanDetailsCommand(currentProgram.id, 'from');
    }
  }
};

export const AlternatePlanChangePlanPopupRoute = <ng.ui.IState>{
  url: 'change-plan',
  data: {
    pageTitle: 'Change plan confirmation'
  },
  resolve: {
    changePlanPopupDetails: (getNonExistingCoursesNewPlanCommand: ICommand) => {
      return getNonExistingCoursesNewPlanCommand();
    }
  }
};

export const AlternatePlanRoutes = {
  'my.planner.alternate-plans': { ...AlternatePlanRoute },
  'my.planner.alternate-plans.change-plan': {
    ...AlternatePlanChangePlanPopupRoute,
    views: {
      'modal@my.planner.alternate-plans': {
        template: `<alternate-plan-change-plan-popup></alternate-plan-change-plan-popup>`
      }
    }
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/ap_alternate_plan_routes.ts